// Taken from https://github.com/vivek12345/react-polling-hook
// The repo looked fairly inactive, it's an MIT license and as such decided it simpler to copy into place and amend if need be, rather than add the dependency

import usePolling from './use-polling';

export default usePolling;
